import { getAuth } from '@/stores/auth';
import { getCompatibilityChecked, setCompatibilityChecked } from '@/stores/device';
import { checkBrowserCompatibility } from '@/utils/check-browser-compatibility';

export function homeRouteLoader() {
  return {
    promises: Promise.all([checkBrowserCompatibility(), getCompatibilityChecked(), getAuth()]).then(
      ([isBrowserCompatible, isCompatibilityChecked, isAuthenticated]) => {
        if (isBrowserCompatible) setCompatibilityChecked();

        return {
          isBrowserCompatible,
          isCompatibilityChecked,
          isAuthenticated,
        };
      },
    ),
  };
}

export type HomeRouteLoaderData = ReturnType<typeof homeRouteLoader>;
